var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIconWithBlueBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#5E4DE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6089 14.3167H14.0778V18.9116H12.2696V14.3167H7.75977V12.6787H12.2696V8.0625H14.0778V12.6787H18.6089V14.3167Z",
    fill: "#E4E0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconWithBlueBack);
export default __webpack_public_path__ + "static/media/PlusIconWithBlueBack.33a18bb41945c3970804281df78ef088.svg";
export { ForwardRef as ReactComponent };